import axios from 'axios';

const API = axios.create({
  baseURL: 'https://advisormitra.com' // Correct: Base URL for backend API
});

export const createAgent = (agentData) =>
  API.post('/agents/register', agentData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const createBulkAgents = (agentData) =>
  API.post('/agents/bulkregister', agentData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const getAgentsByOwnerId = (userId) => {
  return API.get(`/agents/owner/${userId}`);
};

export const findAgentsWithDetailsByOwnerId = (userId) => {
  return API.get(`/agents/owners/${userId}`);
};

export const getOrganizations = () => {
  return API.get('/organizations');
};

export const getRoles = () => {
  return API.get('/roles');
};

export const getSubscriptionsByAgentId = (agentId) => {
  return API.get(`/subscriptions/agent/${agentId}`);
};

export const uploadPdf = (formData) => {
  return API.post('/pdf/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const loginUser = (username, password) => {
  return API.post('api/users/login', { username, password });
  
};

export const registerUser = (user) => {
  return API.post('/auth/register', user);
};

export const changePassword = (userId, oldPassword, newPassword) => {
  return API.post('/users/change-password', {
    id: userId,
    oldPassword,
    newPassword,
  });
};

// Moved to top level
export const getAgentByEmail = (email) => {
  return API.get(`/agents/email/${encodeURIComponent(email)}`);
};
// Fetch last login timestamp for a user by username
export const getLastLogin = (username) => {
  return API.get(`/users/last-login/${username}`);
};  
// Fetch report based on agent id 
export const getReportByAgentId = (agentId) => {
  return API.get(`reports/reportdetails/${agentId}`);
};